// extracted by mini-css-extract-plugin
export var backgroundColor = "background_color-module--backgroundColor--Zb6Dg";